import { PropTypes } from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideDialog } from '../actions';
import { Lightbox } from './Lightbox';

class LightboxDialog extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    mediaFile: PropTypes.shape({}),
    type: PropTypes.number.isRequired,
    closeDialog: PropTypes.func.isRequired,
  };

  render() {
    const { closeDialog, isOpen, mediaFile, type } = this.props;
    return (
      <Lightbox
        isOpen={isOpen}
        onClose={closeDialog}
        fileName={mediaFile.description}
        mediaUrl={mediaFile.downloadUrl}
        type={type}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeDialog: hideDialog,
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(LightboxDialog);
